const financialRoutes = [
    {
        path: "/financial",
        name: "financial",
        redirect: 'financial/account',
        component: () => import("@/views/financial/Financial"),
        children: [


            {
                path: "/financial/extract",
                name: "financialExtract",
                component: () => import("@/views/financial/FinancialExtract")
            },
            {
                path: "/financial/movements",
                name: "financialMovements",
                component: () => import("@/views/financial/FinancialMovements")
            },
            {
                path: "/financial/plan",
                name: "financialMyPlan",
                component: () => import("@/views/financial/FinancialMyPlan")
            },
            {
                path: "/financial/registers",
                name: "financialRegisters",
                component: () => import("@/views/financial/FinancialRegisters")
            },


        ]
    },
    {
        path: "/financial/accounts",
        name: "financialAccounts",
        component: () => import("@/views/financial/FinancialAccounts")
    },
    {
        path: "/financial/accounts/add",
        name: "financialAddAccounts",
        component: () => import("@/views/financial/FinancialAddAccount")
    },
    {
        path: "/financial/account",
        name: "financialAccount",
        component: () => import("@/views/financial/FinancialAccount")
    },
    {
        path: "/cashFlow",
        name: "cashFlow",
        component: () => import("@/views/financial/CashFlow")
    },
    {
        path: "/invoices",
        name: "invoices",
        component: () => import("@/views/financial/Invoices")
    },
    {
        path: "/financial/:id",
        name: "financialView",
        component: () => import("@/views/financial/Finance"),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },

    // {
   //     path: "/profile/edit",
   //     name: "editProfile",
   //     component: () => import("@/views/profile/EditProfile")
   //}
]
export default financialRoutes